export const globalErrorModalOptions = (error) => {

  return {
    title: "エラー",
    size: 'md',
    buttonSize: 'md',
    headerBgVariant: 'danger',
    okVariant: 'danger',
    okTitle: 'YES',
    cancelTitle: 'NO',
    footerClass: 'p-2',
    hideHeaderClose: false,
    centered: true,
    // titleTag:'',
    // scrollable:'',
    // noFade:'',
    // noCloseOnBackdrop:'',
    // noCloseOnEsc:'',
    // headerBorderVariant:'',
    // headerTextVariant:'',
    // headerCloseVariant:'',
    // headerClass:'',
    // bodyBgVariant:'',
    // bodyBorderVariant:'',
    // bodyTextVariant:'',
    // bodyClass:'',
    // footerBgVariant:'',
    // footerBorderVariant:'',
    // footerTextVariant:'',
    // headerCloseLabel:'',
    // cancelVariant:'',
  }
}
